// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Vpug","location":"Header_location__X6Ams"};